module.exports = __webpack_public_path__ + "img/feedback7-2.fd40b7e3.jpg";